<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </section>
</template>
<script>
export default {
  name: "AppMain",
  computed: {
    key() {
      return this.$route.path;
    }
  }
};
</script>
<style lang="scss" scoped>
.app-main {
  background: #f4f5f7;
  padding: 0;
  height: calc(100vh - 54px);
  overflow: auto;
  & > div {
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(4, 46, 111, 0.08);
    border-radius: 9px 10px 0px 0px;
    margin: 20px 15px;
    min-height: calc(100% - 40px);
    overflow: hidden;
    padding: 30px 24px;
  }
}
</style>
